<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-title">CONTENTS</p>
<p class="toc"><a href="#/Foreword">Foreword, by Frank Billingsley</a></p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1">Founding Fathers…and Mothers</a></p>
<p class="toc"><span href="#/Chapter2" title="Link target outside of Sample">Island Entrepreneurs</span></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">Saints and Sinners</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">Undersung Heroes and Heroines</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">Local Legends</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">BOIs Off the Island</span></p>
<p class="toc1"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?32aac7c7